import { httpRequest } from "../../http";
import type { FileColumns } from "@models/fieldMap.model";

export class CommandGetFileColumns {
  async run(definitionId: number): Promise<FileColumns> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/file-columns/`;
    return httpRequest<FileColumns>(url, { method: "GET" });
  }
}
